import { BehaviorSubject, Observable, Subject } from 'rxjs';
/* eslint-disable no-underscore-dangle */
import { Injectable, OnDestroy } from '@angular/core';
import { ResourceVm } from 'qp-ui-interface';
import {
  IDetailResource,
  VerticalMenuEvent,
} from './shared/common/interfaces/common.interface';
import { PlanProcessData } from './shared/interfaces/viewPlans.interfaces';
import { LocalStorageService } from './shared/services/storage/local-storage.service';
import { KEYS } from './shared/utils/constants/storage.constants';

@Injectable({
  providedIn: 'root',
})
export class DataService implements OnDestroy {
  skipPreferredLanguageSelection: boolean;
  isLoggingOut: boolean = false;

  constructor(private readonly localStorage: LocalStorageService) {}

  // store if the continue watching from storefront need to restart the position
  private updatecontinueWatchingPosition: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  // size and theme configuration
  private sizesubtitles: string[] = ['s', 'm', 'l', 'xl'];
  private themesubtitles: string[] = ['bw', 'gw', 'by', 'wb', 'gb'];
  // store the time when the config is loaded
  private storeFrontTime = 0;
  // store the active tab
  private activetab = '';
  // store the id of the home tab
  private homeTabId = '';
  // store the details url
  private detailsurl = '';
  // store if the profile is predefined
  private ispredefinedProfile = false;
  // store the collection
  private _collection = {
    collectionName: '',
    collectionId: '',
  };
  // hero intervals
  private interHero: number | undefined;
  // store the backroutes
  private backroutes: string[] = [];
  // store init load
  private initiaLLoad = true;
  //store the config time
  private configtime = 0;
  // store if the user has selected a profile
  private profileSelected = false;
  //previus an current url
  private currenturl = '';
  private previousurl = '';
  //reload my-aha
  private reloadmyaha = false;
  // is from deeplink
  private isFromdeeplink = false;
  // is from continue watching carousel (my-aha or storefront)
  private iscontinuewatching = false;
  // selected card from storefront (most of the times, get live data)
  private selectedcarddata: ResourceVm | null = null;
  // store the current resource container
  private currentresourceContainerName = '';
  // store the current resource containerId
  private currentresourceContainerId = '';
  // store the value needed to buy plan from view plans
  private viewplanData: PlanProcessData | null = null;

  // store if the parental pin is enabled for a profile or not
  private parentalValue = false;
  // store if we need to reset the focos on genres page
  private resetGenresFocus = false;
  // check if tizen priview was already shown
  private tizenPreviewShown = false;
  // playback start time
  private playbackStartedTime = 0;
  //Time taken for parental dialog
  private parentalDialogTime = 0;
  // content is played directly without details
  private redirectToPlayer = false;
  // store screen resolution
  private screenResolution: { width: number; height: number } = {
    width: 0,
    height: 0,
  };

  private currentresourcePositionInTray: string | number | undefined = undefined;

  private _isSearchGridFocused = new Subject<boolean>();

  private _horizontalIndex: number; // New property for horizontal index
  private _verticalIndex: number; // New property for vertical index

  private _isFromLinkTv = false;

  private _isSubscribeOrUpgradeClicked: boolean;
  private _isLanguageClicked: boolean;
  private _isSettingsClicked: boolean;
  private _isAnonyLinkTvClicked: boolean;
  private _isAnonySettingsClicked: boolean;
  private _isPlansPageHorizontalIndex: number;

  private _myahaContentIndex: number;

  // Track if APP_START event has been sent this session
  private appStartSent = false;

  // Track pending deeplink URL (for onboarding flow)
  private pendingDeeplinkUrl: string | null = null;

  get myahaContentIndex(): number {
    return this._myahaContentIndex;
  }

  set myahaContentIndex(value: number) {
    this._myahaContentIndex = value;
  }

  private _currentRes: BehaviorSubject<ResourceVm | null> =
    new BehaviorSubject<ResourceVm | null>(null);

  private _currentComponent: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  get isFromLinkTv(): boolean {
    return this._isFromLinkTv;
  }

  set isFromLinkTv(value: boolean) {
    this._isFromLinkTv = value;
  }

  get currentComponent(): Observable<any> {
    return this._currentComponent.asObservable();
  }

  get currentComponentValue(): any {
    return this._currentComponent.value;
  }

  set setCurrentComponent(component: any) {
    this._currentComponent.next(component);
  }

  get isTizenPreviewShown(): boolean {
    return this.tizenPreviewShown;
  }

  get horizontalIndex(): number {
    return this._horizontalIndex;
  }

  set horizontalIndex(value: number) {
    this._horizontalIndex = value;
  }

  get verticalIndex(): number {
    return this._verticalIndex;
  }

  set verticalIndex(value: number) {
    this._verticalIndex = value;
  }

  set isTizenPreviewShown(value: boolean) {
    this.tizenPreviewShown = value;
  }

  get isRedirectToPlayer(): boolean {
    return this.redirectToPlayer;
  }

  set isRedirectToPlayer(value: boolean) {
    this.redirectToPlayer = value;
  }

  get resetGenresFocusValue(): boolean {
    return this.resetGenresFocus;
  }

  set resetGenresFocusValue(value: boolean) {
    this.resetGenresFocus = value;
  }

  get playbackStartTime(): number {
    return this.playbackStartedTime;
  }

  set playbackStartTime(value: number) {
    this.playbackStartedTime = value;
  }

  get parentalDisplayDuration(): number {
    return this.parentalDialogTime;
  }

  set parentalDisplayDuration(value: number) {
    this.parentalDialogTime = value;
  }

  get sizeSubtitles(): string[] {
    return this.sizesubtitles;
  }

  get themeSubtitles(): string[] {
    return this.themesubtitles;
  }

  get storefrontTime(): number {
    return this.storeFrontTime;
  }

  set storefrontTime(value: number) {
    this.storeFrontTime = value;
  }

  get activeTab(): string {
    return this.activetab;
  }

  set activeTab(value: string) {
    this.activetab = value;
  }

  get homeTab(): string {
    return this.homeTabId;
  }

  set homeTab(value: string) {
    this.homeTabId = value;
  }

  get detailsUrl(): string {
    return this.detailsurl;
  }

  set detailsUrl(value: string) {
    this.detailsurl = value;
  }

  get isPredefinedProfile(): boolean {
    return this.ispredefinedProfile;
  }

  set isPredefinedProfile(value: boolean) {
    this.ispredefinedProfile = value;
  }

  get collection(): { collectionName: string; collectionId: string } {
    return this._collection;
  }

  set collection(value: { collectionName: string; collectionId: string }) {
    this._collection = { ...this._collection, ...value };
  }

  get inter(): any {
    return this.interHero;
  }

  set inter(interval: any) {
    this.interHero = interval;
  }

  get backRoutes(): string[] {
    return this.backroutes;
  }

  set backRoutes(value: string[]) {
    this.backroutes = value;
  }

  get initialLoad(): boolean {
    return this.initiaLLoad;
  }

  set initialLoad(value: boolean) {
    this.initiaLLoad = value;
  }

  get configTime(): number {
    return this.configtime;
  }

  set configTime(value: number) {
    this.configtime = value;
  }

  get profileSelectedStatus(): boolean {
    return this.profileSelected;
  }

  set profileSelectedStatus(value: boolean) {
    this.profileSelected = value;
  }

  get previousUrl(): string {
    return this.previousurl;
  }

  set previousUrl(url: string) {
    this.previousurl = url;
  }

  get currentUrl(): string {
    return this.currenturl;
  }

  set currentUrl(url: string) {
    this.currenturl = url;
  }

  get reloadMyAha(): boolean {
    return this.reloadmyaha;
  }

  set reloadMyAha(value: boolean) {
    this.reloadmyaha = value;
  }

  get isFromDeeplink(): boolean {
    return this.isFromdeeplink;
  }

  set isFromDeeplink(value: boolean) {
    this.isFromdeeplink = value;
  }

  get isSubscribeOrUpgradeClicked(): boolean {
    return this._isSubscribeOrUpgradeClicked;
  }

  set isSubscribeOrUpgradeClicked(value: boolean) {
    this._isSubscribeOrUpgradeClicked = value;
  }

  get isSettingsClicked(): boolean {
    return this._isSettingsClicked;
  }

  set isSettingsClicked(value: boolean) {
    this._isSettingsClicked = value;
  }

  get isLanguageClicked(): boolean {
    return this._isLanguageClicked;
  }

  set isLanguageClicked(value: boolean) {
    this._isLanguageClicked = value;
  }

  get isAnonyLinkTvClicked(): boolean {
    return this._isAnonyLinkTvClicked;
  }

  set isAnonyLinkTvClicked(value: boolean) {
    this._isAnonyLinkTvClicked = value;
  }

  get isAnonySettingsClicked(): boolean {
    return this._isAnonySettingsClicked;
  }

  set isAnonySettingsClicked(value: boolean) {
    this._isAnonySettingsClicked = value;
  }

  get isPlansPageHorizontalIndex(): number {
    return this._isPlansPageHorizontalIndex;
  }

  set isPlansPageHorizontalIndex(value: number) {
    this._isPlansPageHorizontalIndex = value;
  }

  get isAppStartSent(): boolean {
    return this.appStartSent;
  }

  set isAppStartSent(value: boolean) {
    this.appStartSent = value;
  }

  get getPendingDeeplinkUrl(): string | null {
    return this.pendingDeeplinkUrl;
  }

  set setPendingDeeplinkUrl(value: string | null) {
    this.pendingDeeplinkUrl = value;
  }

  getUpdateContinueWatchingPosition(): Observable<boolean> {
    return this.updatecontinueWatchingPosition.asObservable();
  }

  setUpdateContinueWatchingPosition(val: boolean): void {
    this.updatecontinueWatchingPosition.next(val);
  }

  get selectedCardData(): ResourceVm | null {
    return this.selectedcarddata;
  }

  get isContinueWatching(): boolean {
    return this.iscontinuewatching;
  }

  set isContinueWatching(iscw: boolean) {
    this.iscontinuewatching = iscw;
  }

  get currentResourceContainerName(): string {
    return this.currentresourceContainerName;
  }

  set currentResourceContainerName(name: string) {
    this.currentresourceContainerName = name;
  }

  get currentResourceContainerId(): string {
    return this.currentresourceContainerId;
  }

  set currentResourceContainerId(name: string) {
    this.currentresourceContainerId = name;
  }

  get viewPlanData(): PlanProcessData | null {
    return this.viewplanData;
  }

  set viewPlanData(data: PlanProcessData | null) {
    this.viewplanData = data;
  }

  get isParentalEnabled(): boolean {
    return this.parentalValue;
  }

  set isParentalEnabled(value: boolean) {
    this.parentalValue = value;
  }

  get currentResource(): Observable<ResourceVm | null> {
    return this._currentRes.asObservable();
  }

  get currentResourceValue(): ResourceVm | null {
    return this._currentRes.value;
  }

  set selectedCardData(resource: ResourceVm | null) {
    this._currentRes.next(resource);
    this.selectedcarddata = resource;
  }

  get isSearchGridFocused(): Observable<boolean> {
    return this._isSearchGridFocused.asObservable();
  }

  setSearchGridFocused(value: boolean) {
    this._isSearchGridFocused.next(value);
  }

  // for routing tab selection do not remove search, aha only
  previousTabId: string | null = null;

  private _showLinkTvSuccessToast = false;

  get showLinkTvSuccessToast(): boolean {
    return this._showLinkTvSuccessToast;
  }

  set showLinkTvSuccessToast(value: boolean) {
    this._showLinkTvSuccessToast = value;
  }

  // validateSubscription: boolean = false;

  detailResource: IDetailResource | null = null;

  forcePlayVideo: boolean = false;
  disablePlayerListener: boolean = false;

  private _verticalMenuEvent = new Subject<VerticalMenuEvent>();
  private _verticalMenuLastEvent: VerticalMenuEvent | null = null;

  get verticalMenuEvent(): Observable<VerticalMenuEvent> {
    return this._verticalMenuEvent.asObservable();
  }

  emitVerticalMenuEvent(value: VerticalMenuEvent) {
    if (value.data?.selectedIndex > -1) {
      this._verticalMenuLastEvent = value;
    }
    this._verticalMenuEvent.next(value);
  }

  ngOnDestroy() {
    // Complete all subjects
    this._isSearchGridFocused.complete();
    this._currentRes.complete();
    this._currentComponent.complete();
    this._verticalMenuEvent.complete();
    this.updatecontinueWatchingPosition.complete();
  }

  // Add cleanup method for manual cleanup
  cleanup() {
    this._isSearchGridFocused.complete();
    this._currentRes.complete();
    this._currentComponent.complete();
    this._verticalMenuEvent.complete();
    this.updatecontinueWatchingPosition.complete();

    // Clear all stored data
    this._collection = {
      collectionName: '',
      collectionId: '',
    };
    this.backroutes = [];
    this.selectedcarddata = null;
    this.currentresourceContainerName = '';
    this.currentresourceContainerId = '';
    this.viewplanData = null;
  }

  get verticalMenuLastEvent(): VerticalMenuEvent | null {
    return this._verticalMenuLastEvent;
  }

  clearVerticalMenuLastEvent() {
    this._verticalMenuLastEvent = null;
  }

  gridFocusPosition: { verticalIndex: number; horizontalIndex: number } = {
    verticalIndex: 0,
    horizontalIndex: 0,
  };

  storefrontScrollPosition: { scrollTop: number; scrollLeft: number } = {
    scrollTop: 0,
    scrollLeft: 0,
  };

  collectionStorefrontScrollPosition: {
    scrollTop: number;
    scrollLeft: number;
  } = {
    scrollTop: 0,
    scrollLeft: 0,
  };

  storefrontLastIndex: {
    hIndex?: number;
    vIndex?: number;
  } = null;

  forceOpenMyAha = false;
  /* Do not remove this property will use for intermediate login*/
  isIntermediateLogin = false;

  myAhaLastFocusedIndex: number = null;

  shouldSkipResolver = false;
  searchFocus: { element: string; index: number } = null;

  get resolution(): { width: number; height: number } {
    return this.screenResolution;
  }

  set resolution(value: { width: number; height: number }) {
    this.screenResolution = value;
  }

  get currentResourcePositionInTray(): string | number | null {
    return this.currentresourcePositionInTray;
  }

  set currentResourcePositionInTray(position: string | number | null) {
    this.currentresourcePositionInTray = position;
  }
}
